import { HoverCard } from "office-ui-fabric-react";
import React, { Component } from "react";
import { MyContext } from "../../../context";
import { FontIcon } from "office-ui-fabric-react/lib";

export default class HoverCardFolders extends Component {
  static contextType = MyContext;

  constructor(props) {
    super(props);
    const caseIds = (props.incidents ?? []).map((incident) => incident.caseId);
    const filteredFolders = (props.foldersData ?? []).filter((folder) => !caseIds.includes(folder.id));
    this.state = {
      folders: props.foldersData == undefined ? null : filteredFolders,
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.foldersData !== this.props.foldersData || prevProps.incidents !== this.props.incidents) {
      const caseIds = (this.props.incidents ?? []).map((incident) => incident.caseId);
      const filteredFolders = (this.props.foldersData ?? []).filter((folder) => !caseIds.includes(folder.id));
      this.setState({
        folders: this.props.foldersData == undefined ? null : filteredFolders,
      });
    }
  }

  plainCardProps = {
    onRenderPlainCard: () => {
      return (
        <MyContext.Consumer>
          {(context) => (
            <div>
              <div style={{ padding: "10px" }}>
                <div>
                  {this.state.folders != null ? (
                    this.state.folders.map((folder, item) => <div key={item}>{folder.name}</div>)
                  ) : (
                    <div>{this.context.getTranslation("common", "loading")}</div>
                  )}
                  {this.state.folders != null && this.state.folders.length == 0 && (
                    <div>{this.context.getTranslation("detailContainer", "notInSafeFolder")}</div>
                  )}
                </div>
              </div>
            </div>
          )}
        </MyContext.Consumer>
      );
    },
  };

  render() {
    return (
      <HoverCard expandingCardProps={this.expandingCardProps} plainCardProps={this.plainCardProps} instantOpenOnClick={true} type="PlainCard">
        <div>
          <div style={{ display: "flex", flexDirection: "row" }}>
            {this.state.folders != null && this.state.folders.length > 0 && (
              <div>
                <FontIcon aria-label="LockSolid" iconName="LockSolid" />
                {` ${this.context.getTranslation("detailContainer", "folders")} (${this.state.folders.length})`}
              </div>
            )}
            {this.state.folders != null && this.state.folders?.length === 0 && this.props.incidents?.length === 0 && (
              <div>
                <FontIcon aria-label="LockSolid" iconName="LockSolid" />
                {` ${this.context.getTranslation("detailContainer", "folders")} (${this.context.getTranslation("detailContainer", "folderUnallocated")})`}
              </div>
            )}
          </div>
        </div>
      </HoverCard>
    );
  }
}
